import {Component} from '@angular/core';

@Component({
  selector: 'greydom-member-onboarding-portal',
  template: `
    <router-outlet></router-outlet>
  `
})
export class OnboardingAdminPortalComponent {
}
